import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import {
  dailyCutCashOutDetailsPage,
  dailyCutCashOutPage,
  payAllProductsPage,
  payAllServicesPage
} from '@/__mocks__/modules/services/data.ts'

export default [
  {
    method: 'GET',
    path: '/payall_product?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, payAllProductsPage]
    }
  },
  {
    method: 'GET',
    path: '/payall_service/1?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, payAllServicesPage]
    }
  },
  {
    method: 'PUT',
    path: '/payall_service/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/payall/daily/cut?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, dailyCutCashOutPage]
    }
  },
  {
    method: 'GET',
    path: '/payall/daily/cut?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, dailyCutCashOutPage]
    }
  },
  {
    method: 'GET',
    path: '/payall/details_recharge/1?limit=20&page=1',
    reply: async () => {
      await wait()
      return [status.ok, dailyCutCashOutDetailsPage]
    }
  },
  {
    method: 'POST',
    path: '/payall/process?bank=bdv',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
